import { X } from "lucide-react";

export function SearchResults({ results, onClose, onOpenUser }) {
  if (!results) return null;
  return (
    <div className="px-4 md:px-8 pb-6">
      <div className="flex items-center justify-between mb-3">
        <div className="text-xs tracking-[0.3em] font-mono text-[#00E5FF]">// AI MATCH SET</div>
        <button data-testid="close-search-btn" onClick={onClose} className="text-white/40 hover:text-white"><X size={16} /></button>
      </div>
      {results.explanation && (
        <p className="text-sm text-white/60 mb-3 italic">&ldquo;{results.explanation}&rdquo;</p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {results.matches.map((u) => (
          <button
            key={u.id}
            data-testid={`search-result-${u.id}`}
            onClick={() => onOpenUser(u)}
            className="text-left p-4 bg-[#0D0E15] border border-white/10 rounded-xl hover:border-[#00E5FF] transition-all"
          >
            <div className="flex items-center justify-between">
              <span className="font-[Unbounded]">{u.display_name}</span>
              {u.distance_km !== undefined && <span className="text-xs font-mono text-white/50">{u.distance_km}km</span>}
            </div>
            <p className="text-sm text-white/50 mt-1 line-clamp-1">{u.bio || (u.interests || []).join(" · ") || "No bio yet"}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
